import { render, staticRenderFns } from "./TextTextTextCard.vue?vue&type=template&id=206f2651&scoped=true"
import script from "./TextTextTextCard.vue?vue&type=script&lang=js"
export * from "./TextTextTextCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f2651",
  null
  
)

export default component.exports